export const focusNextInput = (id: string): void => {
  const nextInput = document ? document.getElementById(id) : null
  if (nextInput) {
    nextInput.focus()
  }
}
